<template>
  <div v-for="setting in settings" :key="setting.id">
    Retiré du programme
  </div>
</template>

<script lang="ts" setup>
import {SupportProgramConsumerSettings} from "@/program/interfaces/Program";

defineProps<{
    settings: SupportProgramConsumerSettings[];
}>();
</script>
